// Miniaturen op de demodetailpagina (module demo). Gebundeld naar /js/demo/media.js.
//
// - "3D": het grote vak toont de viewer in de beginstand.
// - ISO, VOOR, ZIJ, BOVEN: vaste aanzichten van dezelfde viewer. Ze verschijnen pas als de viewer
//   klaar is (element.viewer3d of de gebeurtenis "viewer:klaar" van module 3d) en krijgen dan een
//   klein beeld uit de viewer zelf.
// - Een beeld (foto van het origineel, of een render als er geen 3D-model is): het grote vak toont
//   dat beeld en het bijschrift eronder.
// Zonder JavaScript zijn de beeldminiaturen gewone links naar het beeld en staat de viewer er al.

/** Zoals ViewerApi in src/modules/3d/browser/viewer.ts (geen import tussen modules). */
interface ViewerApi {
  aanzicht(naam: string): void;
  aanzichtBeelden(namen: string[], breedte: number, hoogte: number): Record<string, string | undefined>;
}

const DUIM_PX = 128;

function koppel(media: HTMLElement) {
  const paneel3d = media.querySelector<HTMLElement>('[data-paneel="3d"]');
  const figuur = media.querySelector<HTMLElement>('[data-paneel="beeld"]');
  const groot = figuur?.querySelector<HTMLImageElement>("img") ?? null;
  const bijschrift = media.querySelector<HTMLElement>('[data-rol="bijschrift"]');
  const hint3d = media.dataset.hint ?? "";
  const duimen = [...media.querySelectorAll<HTMLElement>(".duim")];
  let api: ViewerApi | null = null;

  const zetBijschrift = (tekst: string) => {
    if (!bijschrift) return;
    bijschrift.textContent = tekst;
    bijschrift.hidden = !tekst;
  };

  const kies = (d: HTMLElement) => {
    for (const x of duimen) x.setAttribute("aria-pressed", String(x === d));
    if (d.dataset.duim === "beeld") {
      if (groot && figuur) {
        groot.src = d.getAttribute("href") ?? groot.src;
        groot.alt = d.dataset.alt ?? "";
        figuur.hidden = false;
      }
      if (paneel3d) paneel3d.hidden = true;
      zetBijschrift(d.dataset.bijschrift ?? "");
      return;
    }
    if (paneel3d) {
      paneel3d.hidden = false;
      if (figuur) figuur.hidden = true;
    }
    api?.aanzicht(d.dataset.duim === "aanzicht" ? (d.dataset.aanzicht ?? "begin") : "begin");
    zetBijschrift(hint3d);
  };

  for (const d of duimen) {
    if (d.tagName === "A") {
      // Met JavaScript wordt een beeldlink een knop die het grote vak wisselt.
      d.setAttribute("role", "button");
      d.setAttribute("aria-pressed", String(d.classList.contains("is-active")));
      d.classList.remove("is-active");
    }
    d.addEventListener("click", (e) => {
      e.preventDefault();
      kies(d);
    });
  }

  const viewer = paneel3d?.querySelector<HTMLElement & { viewer3d?: ViewerApi }>(".viewer");
  if (!viewer) return;
  const klaar = (a: ViewerApi) => {
    api = a;
    const knoppen = duimen.filter((d) => d.dataset.duim === "aanzicht" && d.dataset.aanzicht);
    let beelden: Record<string, string | undefined> = {};
    try {
      beelden = a.aanzichtBeelden(
        knoppen.map((k) => k.dataset.aanzicht!),
        DUIM_PX,
        DUIM_PX,
      );
    } catch {
      beelden = {};
    }
    for (const k of knoppen) {
      const url = beelden[k.dataset.aanzicht!];
      if (url) {
        const img = document.createElement("img");
        img.src = url;
        img.alt = "";
        k.replaceChildren(img);
        k.title = k.getAttribute("aria-label") ?? "";
      }
      const li = k.closest("li");
      if (li) li.hidden = false;
    }
  };
  if (viewer.viewer3d) klaar(viewer.viewer3d);
  else viewer.addEventListener("viewer:klaar", (e) => klaar((e as CustomEvent<ViewerApi>).detail), { once: true });
}

for (const media of document.querySelectorAll<HTMLElement>("[data-demo-media]")) koppel(media);
